import { Configuration, LogLevel } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
export const msalConfig: Configuration = {
  auth: {
    clientId:environment.AZURE_ENTRA_CLIENTID,
    authority: environment.AZURE_ENTRA_AUTHORITY,
    redirectUri: environment.AZURE_ENTRA_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage', // or sessionStorage
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        console.log(message);
      },
      logLevel: LogLevel.Info,
    },
  },
};

export const loginRequest = {
  scopes: ['User.Read'], // request Microsoft Graph or custom API permissions
};